
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import Page from "@/components/molecules/Page.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import Table from "@/components/molecules/Table.vue";
import MonthlyReport from "./MonthlyReport.vue";
import { AsApi, GetAsBroadcasts, AsBroadcastTypeEnum, PricePlanEnum } from "../../../autogen";
import SearchField from "../../atoms/SearchField.vue";
import moment from "moment-timezone";
import UIkit from "uikit";
import ASGroupForm from "./ASGroupForm.vue";
import Store from "../../../store";

import Toggle from "@vueform/toggle";
import FieldLabel from "../../atoms/FieldLabel.vue";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    MonthlyReport,
    SearchField,
    ASGroupForm,
    Toggle,
    FieldLabel
  }
})
export default class ASGroup extends Vue {
  @Ref("monthly-report")
  monthlyReport!: HTMLElement;
  @Ref("editor")
  editor!: HTMLElement;
  query = "";
  broadcasts: (GetAsBroadcasts & {
    typeName: string;
    term: string;
    count: string;
  })[] = [];
  broadCast?: GetAsBroadcasts;
  header = [
    { title: "種別", sortable: true, key: "typeName", width: 150 },
    { title: "実施内容名", sortable: true, key: "name", width: "expand" },
    { title: "受検期間", key: "term", width: "expand" },
    { title: "受検人数", key: "count", width: 150 },
    { title: "詳細", type: "button", key: "detail", width: 150 }
  ];
  filterColumns = ["name", "typeName", "term"];
  editorFormKey = 0;
  private readonly authStore = Store.getInstance();
  isTrial = true;
  onPeriod = true;
  excludeCompletion = false;
  type: AsBroadcastTypeEnum | "all" = "all";
  types = [
    { label: "全て", value: "all" },
    { label: "従業員", value: AsBroadcastTypeEnum.Employee },
    { label: "応募者", value: AsBroadcastTypeEnum.Applicant }
  ] as const;
  renewKey = 0;

  async loadData() {
    if (sessionStorage.getItem("asgConditions")) {
      const storedConditions = JSON.parse(sessionStorage.getItem("asgConditions")!);
      this.type = storedConditions.type;
      this.onPeriod = storedConditions.period;
      this.excludeCompletion = storedConditions.excludeCompletion;
    }
    const response = await new AsApi().getAsBroadcasts({
      q: this.query,
      onPeriod: this.onPeriod,
      excludeCompletion: this.excludeCompletion,
      type: this.type === "all" ? undefined : this.type
    });
    this.broadcasts = response.data.map(d =>
      Object.assign(
        {
          typeName: d.type === AsBroadcastTypeEnum.Employee ? "従業員" : "応募者",
          term: `${moment(d.startDateTime).format("YYYY月MM月DD日")}
            ~ ${moment(d.endDateTime).format("YYYY月MM月DD日")}`,
          count: `${d.participatedCount} / ${d.participantsCount}`
        },
        d
      )
    );
    const planCode = this.authStore.getAuth()!.pricePlan;
    this.isTrial = planCode === PricePlanEnum.Trial;
    this.renewKey = Date.now();
  }
  async beforeMount() {
    await this.loadData();
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "detail") {
      const broadcast = this.broadcasts[location.row];
      this.$router.push(`/clients/${this.$route.params["clientId"]}/as/group/${broadcast.asBroadcastId}`);
    }
  }
  onMonthlyReportButtonClick() {
    UIkit.modal(this.monthlyReport).show();
  }
  async forceOnSearch() {
    sessionStorage.setItem(
      "asgConditions",
      JSON.stringify({ type: this.type, period: this.onPeriod, excludeCompletion: this.excludeCompletion })
    );
    await this.loadData();
  }
  async onSearch(searchResult: [] | null) {
    if (searchResult) {
      this.broadcasts = searchResult;
    } else {
      await this.loadData();
    }
  }
  onAddButtonClick() {
    this.editorFormKey = Date.now();
    UIkit.modal(this.editor).show();
  }
  async onGroupFormSubmitted() {
    UIkit.modal(this.editor).hide();
    await this.loadData();
  }
}
